const SET_SNACK_BAR_VALUES = 'app/notifs/SET_SNACK_BAR_VALUES';
const SET_SNACK_BAR_VALUES_SAGA = 'app/notifs/SET_SNACK_BAR_VALUES_SAGA';
const CLOSE_SNACK_BAR = 'app/notifs/CLOSE_SNACK_BAR';

export {
  SET_SNACK_BAR_VALUES_SAGA,
  SET_SNACK_BAR_VALUES,
  CLOSE_SNACK_BAR,
};
